// extracted by mini-css-extract-plugin
export default {"mainWrraper":"style_mainWrraper__mGx7I","collapseWrraper":"style_collapseWrraper__1L5aC","plusIcon":"style_plusIcon__p4WOH"};